import React from "react";
import { FaCommentDots } from "react-icons/fa";
import useModal from "../../hooks/useModal";
import Modal from "../molecules/Modal";
import ModalViewOnlineMeeting from "../organisms/clientes/empresas/reuniones/ModalViewOnlineMeeting";

const MeetStatus = ({ meetingId, nameEnterprice }) => {
	const { open, close, isOpen } = useModal();

	const handleOpen = () => {
		open();
	};
	return (
		<>
			<button
				onClick={handleOpen}
				className="w-90 flex items-center justify-center gap-3 py-3 px-4 rounded-xl bg-rs-azul font-medium border   shadow-sm
				transform transition-transform duration-200 ease-out
				hover:scale-[1.03] active:scale-[0.98]
				focus:outline-none focus:ring-2  focus:ring-offset-2"
			>
				<span>
					<FaCommentDots size={25} color="white" />
				</span>
				<span className="text-white">Reunion en curso - Click para entrar</span>
			</button>
			{isOpen && (
				<Modal
					title="Reunion en curso"
					onClose={close}
					heigth="h-full"
					width="w-full"
				>
					<ModalViewOnlineMeeting
						meetingId={meetingId}
						nameEnterprice={nameEnterprice}
					/>
				</Modal>
			)}
		</>
	);
};

export default MeetStatus;
